import React from "react";
import clsx from "clsx";

import styles from "./CallButton.module.scss";

interface CallButtonProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
  className?: string;
  isMobileFooter?: boolean; // Flag for mobile footer styling
  type?: "button" | "submit" | "reset" | undefined;
}

export default function CallButton({
  children,
  icon,
  onClick,
  disabled = false,
  loading = false,
  fullWidth = false,
  className,
  type = "button",
}: CallButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={clsx(
        styles.button,
        fullWidth && styles.fullWidth,
        disabled && styles.disabled,
        className
      )}
    >
      <span className={styles.shimmer} />

      <span className={styles.content}>
        <span className={styles.text}>{loading ? "Loading..." : children}</span>

        {!loading && icon && <span className={styles.icon}>{icon}</span>}
      </span>
    </button>
  );
}
